'use strict';

// Please note the :visble pseudo only works with jQuery
const FOCUSABLE_ELEMENTS = [
    'button:visible',
    '[href]:visible',
    'input:visible',
    'select:visible',
    'textarea:visible'
];

/**
 * Traps the keyfocus inside the element which selector name is passed
 *
 * @param {String} selector Selector of element to trap the keyfocus in
 * @returns {Boolean | void} false if selector is not a string or empty
 */
const setFocusTrap = (selector) => {
    if (typeof selector !== 'string' || selector.trim().length === 0) {
        return false;
    }

    const focusableElements = $(selector).find(FOCUSABLE_ELEMENTS.join(','));
    const firstElement = focusableElements[0];
    const lastElement = focusableElements[focusableElements.length - 1];

    firstElement.focus();

    $(selector).off('keydown').on('keydown', function(e) {
        if (e.key === 'Tab') {
            if (e.shiftKey && document.activeElement === firstElement) {
                e.preventDefault();
                lastElement.focus();
            } else if (!e.shiftKey && document.activeElement === lastElement) {
                e.preventDefault();
                firstElement.focus();
            }
        }
    });
};

module.exports = {
    set: setFocusTrap
};
